module.exports = __webpack_public_path__ + "img/poste-pay.692786b.svg";